/* Native Shopify cart, search, product forms and consent are deliberately untouched. */
(() => {
  'use strict';
  const desktop = window.matchMedia('(min-width: 1001px)');
  function enhanceMenus() {
    document.querySelectorAll('[data-ml-menu]').forEach((menu) => {
      if (menu.dataset.mlReady) return;
      menu.dataset.mlReady = 'true';
      const trigger = menu.querySelector('summary');
      const sync = () => {
        trigger.setAttribute('aria-expanded', String(menu.open));
        trigger.setAttribute('aria-label', menu.open ? 'Close menu' : 'Open menu');
      };
      const close = (restoreFocus = false) => {
        if (!menu.open) return;
        menu.open = false;
        sync();
        if (restoreFocus) trigger.focus();
      };
      menu.addEventListener('toggle', sync);
      menu.addEventListener('click', (event) => {
        if (event.target.closest('a')) close();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close(true);
      });
      document.addEventListener('click', (event) => {
        if (!menu.contains(event.target)) close();
      });
      desktop.addEventListener('change', (event) => {
        if (event.matches) close();
      });
      sync();
    });
  }
  enhanceMenus();
  document.addEventListener('shopify:section:load', enhanceMenus);
})();
